import React, { useState, useEffect, useCallback } from "react";
import "./Gallery.css";
import imageList from "./imageManifest.json";

const IMAGES_PER_LOAD = 12; // How many images to load at a time

const Gallery = () => {
  const [visibleCount, setVisibleCount] = useState(IMAGES_PER_LOAD);
  // Tracks which image is currently clicked for fullscreen (null means closed)
  const [selectedImage, setSelectedImage] = useState(null);

  const allImages = imageList.map((fileName, index) => ({
    id: index,
    src: `/images/${fileName}`,
    alt: `Handcrafted art piece ${index + 1}`,
  }));

  // Create a smaller array containing only the currently visible images
  const visibleImages = allImages.slice(0, visibleCount);

  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 150 >=
      document.documentElement.offsetHeight
    ) {
      // Add more images to the visible count, without exceeding the total
      setVisibleCount((prevCount) =>
        Math.min(prevCount + IMAGES_PER_LOAD, allImages.length),
      );
    }
  }, [allImages.length]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll); // Cleanup on unmount
  }, [handleScroll]);

  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [selectedImage]);

  return (
    <div className="craft-portfolio">
      <header className="hero-section">
        <h1 className="brand-title">Les Ateliers Tinndina</h1>
        <p className="brand-subtitle">Handmade Crochet & Fine Jewelry</p>
        <div className="hero-divider"></div>
      </header>

      <div className="elegant-masonry">
        {visibleImages.map((image) => (
          <div
            key={image.id}
            className="art-card"
            onClick={() => setSelectedImage(image)}
          >
            <div className="image-wrapper">
              <img src={image.src} alt={image.alt} loading="lazy" />
              <div className="hover-overlay">
                <span className="view-text">Expand ⤢</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div
          className="lightbox-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="lightbox-close"
            onClick={() => setSelectedImage(null)}
            aria-label="Close fullscreen"
          >
            &times;
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="lightbox-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;
